import React from 'react';
import {
  motion,
  AnimatePresence,
  MotionConfig,
  type HTMLMotionProps,
  type MotionConfigProps,
} from 'framer-motion';

// Extended type to explicitly include className which is valid but may not be inferred.
type MotionDivProps = HTMLMotionProps<'div'> & { className?: string };

export interface WithTransitions {
  isVisible: boolean;
  motionConfig?: MotionConfigProps;
  motionProps?: MotionDivProps;
}

const MotionDiv = motion.div as unknown as React.FC<MotionDivProps>;

function withTransitions<T extends {}>(WrappedComponent: React.ComponentType<T>) {
  return (props: WithTransitions & T) => {
    const { isVisible, motionConfig, motionProps } = props;

    return (
      <MotionConfig {...motionConfig}>
        <AnimatePresence mode="popLayout">
          {isVisible && (
            <MotionDiv {...motionProps}>
              <WrappedComponent {...props} />
            </MotionDiv>
          )}
        </AnimatePresence>
      </MotionConfig>
    );
  };
}

export default withTransitions;
